import ACTION_NAMES from 'actions/ACTION_NAMES';
import routes from 'actions/routes';
import { generateReadOneActionCreator } from 'actions/crudActionCreators';
import CRUD_ACTION_TYPES, { getNamedAction } from 'actions/CRUD_ACTION_TYPES';
import mockRecommendationEngine from './mockRecommendationEngine';

// TODO: replace the mock engine with generateCreateActionCreator(routes.API_ONBOARDING_..., ...)
// once the AI Configuration Engine endpoints exist. Action types already match that pattern.
const generateMockActionCreator = (name, request) => (body) => {
    return dispatch => {
        dispatch({ type: getNamedAction(name, CRUD_ACTION_TYPES.CREATE_REQUEST), body });
        return request(body)
            .then(data => {
                dispatch({ type: getNamedAction(name, CRUD_ACTION_TYPES.CREATE_SUCCESS), data });
                return Promise.resolve(data);
            })
            .catch(error => {
                dispatch({ type: getNamedAction(name, CRUD_ACTION_TYPES.CREATE_FAILURE) });
                return Promise.reject(error);
            });
    }
}

// TODO: persist drafts on the backend so progress follows the user across devices
// and is visible on the internal onboarding dashboard.
const getDraftKey = (user_id) => `dyl_onboarding_draft_v2_${user_id}`;

const readDraft = (user_id) => {
    try {
        const draft = window.localStorage.getItem(getDraftKey(user_id));
        return draft ? JSON.parse(draft) : null;
    } catch (e) {
        return null;
    }
}

const saveDraft = (user_id, draft) => {
    try {
        window.localStorage.setItem(getDraftKey(user_id), JSON.stringify({ ...draft, updated_at: new Date().toISOString() }));
    } catch (e) {
        console.log(e);
    }
}

const clearDraft = (user_id) => {
    try {
        window.localStorage.removeItem(getDraftKey(user_id));
    } catch (e) {
        console.log(e);
    }
}

const resetOnboarding = () => ({ type: 'RESET_ONBOARDING' });

export default {
    discoverWebsite: generateMockActionCreator(ACTION_NAMES.ONBOARDING_WEBSITE_DISCOVERY, mockRecommendationEngine.discoverWebsite),
    generateRecommendations: generateMockActionCreator(ACTION_NAMES.ONBOARDING_RECOMMENDATIONS, mockRecommendationEngine.generateRecommendations),
    generateTeamStructure: generateMockActionCreator(ACTION_NAMES.ONBOARDING_TEAM_STRUCTURE, mockRecommendationEngine.generateTeamStructure),
    extractInvites: generateMockActionCreator(ACTION_NAMES.ONBOARDING_EXTRACT_INVITES, mockRecommendationEngine.extractInvites),
    generatePhoneSetup: generateMockActionCreator(ACTION_NAMES.ONBOARDING_PHONE_SETUP, mockRecommendationEngine.generatePhoneSetup),
    draftGreetings: generateMockActionCreator(ACTION_NAMES.ONBOARDING_DRAFT_GREETINGS, mockRecommendationEngine.draftGreetings),
    generateCrmSetup: generateMockActionCreator(ACTION_NAMES.ONBOARDING_CRM_SETUP, mockRecommendationEngine.generateCrmSetup),
    // Real plan features (products-api GetFeatures); reducers/onboarding maps them with toPlanAccess
    readPlanFeatures: generateReadOneActionCreator(routes.API_PRODUCT_FEATURES, ACTION_NAMES.ONBOARDING_PLAN_ACCESS),
    // Seats on the plan: { total_seats, used_seats, open_seats } (products-api SubscriptionSeats)
    readSeats: generateReadOneActionCreator(routes.API_SUBSCRIPTION, ACTION_NAMES.ONBOARDING_PLAN_SEATS, 'seats'),
    generateMessagingSetup: generateMockActionCreator(ACTION_NAMES.ONBOARDING_MESSAGING_SETUP, mockRecommendationEngine.generateMessagingSetup),
    suggestColumnMapping: generateMockActionCreator(ACTION_NAMES.ONBOARDING_COLUMN_MAPPING, mockRecommendationEngine.suggestColumnMapping),
    analyzeImportData: generateMockActionCreator(ACTION_NAMES.ONBOARDING_ANALYZE_IMPORT, mockRecommendationEngine.analyzeImportData),
    getSampleImportFile: generateMockActionCreator(ACTION_NAMES.ONBOARDING_SAMPLE_IMPORT, mockRecommendationEngine.getSampleImportFile),
    generateIntegrationSuggestions: generateMockActionCreator(ACTION_NAMES.ONBOARDING_INTEGRATIONS, mockRecommendationEngine.generateIntegrationSuggestions),
    readDraft,
    saveDraft,
    clearDraft,
    resetOnboarding
};
